import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import clearSession from '../../actions/clear-session';
import { hideModal } from '../../reducers/modalReducer';

import './style.css';

class PaymentKioskOrderCompleteModal extends Component {
  componentDidMount() {
    setTimeout(() => {
      this.props.clearSession();
    }, 1000 * 10);
  }

  render() {
    return (
      <div className="payment-kiosk-order-complete">
        <div className="payment-kiosk-order-complete-container">
          <div className="message">THANK YOU</div>
          <div className="logo">
            <img src={require('../NavBar/icons/treez-logo-green.png')} />
          </div>
        </div>
      </div>
    );
  }
}

PaymentKioskOrderCompleteModal.propTypes = {
  clearSession: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  clearSession: () => dispatch(clearSession()),
  hideModal: () => dispatch(hideModal())
});

export default connect(null, mapDispatchToProps)(PaymentKioskOrderCompleteModal);



// WEBPACK FOOTER //
// ./src/components/PaymentKioskOrderCompleteModal/PaymentKioskOrderCompleteModal.jsx